import Notification from '@kyvg/vue3-notification'

export default defineNuxtPlugin((nuxtApp: any) =>
    nuxtApp.vueApp.use(Notification)
)